export default {
  finishedTasksTitle: {
    id: 'merchant_onboarding_home_finished_tasks_title',
    defaultMessage: 'Your finished tasks',
  },
  headlineTasksTitle: {
    id: 'merchant_onboarding_home_headline_tasks_title',
    defaultMessage: 'Review those mandatory steps',
  },
  tasksToFinishTitle: {
    id: 'merchant_onboarding_home_tasks_to_finish_title',
    defaultMessage: 'Now, you can start your configuration',
  },
  loadingText: {
    id: 'merchant_onboarding_home_loading_text',
    defaultMessage: 'Pouring 1 last cup of coffee before we get to work...',
  },
}
